'use strict';

const { gsap } = require('gsap');
const { ScrollTrigger } = require('gsap/ScrollTrigger');
const { ScrollToPlugin } = require('gsap/ScrollToPlugin');

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollToPlugin);

const initSliders = function (slider, sliderNumber) {
    // Select all the .text-cta-wrapper elements and loop through them using jQuery
    let $textCTAWrapper = slider.find('.parallax-slider .content-region .text-container .text-cta-wrapper');
    $textCTAWrapper.each(function (index) {
        let $this = $(this);
        $this.addClass('text-group-' + sliderNumber + index);
        if (index === 0) {
            $this.addClass('is-active');
        }
        $this.attr('data-text-group', 'asset-group-' + sliderNumber + index);
    });

    // Move the content from `allSlidesTextContent` to the .text-region inside .parallax-titles using jQuery
    let allSlidesTextContent = $textCTAWrapper.get();
    slider.find('.parallax-titles .text-region').html(allSlidesTextContent);

    // Add data-target-group to each asset container
    slider.find('.parallax-slider .content-region .asset-container').each(function (index) {
        let $thisAsset = $(this);
        $thisAsset.attr('data-target-group', 'text-group-' + sliderNumber + index);
        $thisAsset.addClass('asset-group-' + sliderNumber + index);
    });
};

const updateSlidesWidth = function (slider) {
    slider.find('.title-subtext-cta-container').each(function () {
        // Set the width of each element to the current screen width
        $(this).css('width', app.window.width());
    });
};

/**
 * Function getScrollAmount() returns the scroll value left for the content.
 * @param {element} element is the parallax component
 * @returns {number} width of content left to scroll
 */
function getScrollAmount(element) {
    let contentWidth = element.scrollWidth;
    return -(contentWidth - window.innerWidth);
}

/**
 * Function mobileScroll() handles the vertical & horizontal scrolls for content region
 * @param {slider} slider is the parallax component
 */
function mobileScroll(slider) {
    const contents = slider.querySelector('.text-cta-container');
    const tween = gsap.to(contents, {
        x: getScrollAmount(contents),
        duration: 3,
        ease: 'none',
    });

    let startPos;
    if (app.window.width() <= app.grid.xl) {
        startPos = 'top 15%';
    } else {
        startPos = 'top 21%';
    }
    ScrollTrigger.create({
        trigger: slider,
        start: startPos,
        end: () => `+=${getScrollAmount(contents) * -1}`,
        pin: true,
        animation: tween,
        scrub: true,
        invalidateOnRefresh: true,
        ignoreMobileResize: true,
        preventOverlaps: true,
        fastScrollEnd: true,
    });

    ScrollTrigger.observe({
        target: slider,
        type: 'scroll,wheel,pointer,touch',
        onDrag: (self) => {
            gsap.to(slider.querySelector('.content-region'), { scrollTo: { y: `+=${self.deltaX * 10}` } });
        },
    });
}

$(document).ready(function () {
    const parallaxElements = $('.parallax-slider-container');

    parallaxElements.each(function (index) {
        initSliders($(this), index);

        if (app.window.width() <= app.grid.xl) {
            updateSlidesWidth($(this));
        }
    });

    if (app.window.width() <= app.grid.xl) {
        const parallaxContainer = document.querySelectorAll('.parallax-slider-container');
        parallaxContainer.forEach(function (element) {
            mobileScroll(element);
        });
    }

    const intersectionObserver = new IntersectionObserver(
        function (entries) {
            entries.forEach(function (entry) {
                let targetGroupComponent;
                let className = entry.target.dataset.targetGroup ? '.' + entry.target.dataset.targetGroup : '';
                if (className) {
                    // Use jQuery to select the target group component
                    targetGroupComponent = $(className)[0];

                    let mobileCheck = app.window.width() <= app.grid.xl && entry.isIntersecting && entry.intersectionRatio >= 0.6;
                    let desktopCheck = app.window.width() > app.grid.xl && entry.isIntersecting && entry.intersectionRatio >= 0.7;
                    if (mobileCheck || desktopCheck) {
                        $(targetGroupComponent).addClass('is-active').siblings().removeClass('is-active');
                    }
                }
            });
        },
        {
            root: null,
            threshold: [0, 0.6, 0.7],
        }
    );

    parallaxElements.each(function () {
        let $this = $(this);
        $this.find('.asset-container').each(function () {
            intersectionObserver.observe(this);
        });

        $this.find('.title-subtext-title').on('click', function () {
            const titleParent = $(this).closest('.text-cta-wrapper');
            const targetClassName = '.' + titleParent.attr('data-text-group');
            const $targetElement = $(targetClassName);

            if (app.window.width() > app.grid.xl) {
                $('html, body').animate(
                    {
                        scrollTop: $targetElement.offset().top - $('.main-header-component').height() - 50,
                    },
                    1000
                );
            } else {
                const $contentRegion = $this.find('.content-region');
                const selectedAssetPosX = $this.find(targetClassName).get(0).getBoundingClientRect().left;
                $contentRegion.animate({ scrollLeft: $contentRegion.scrollLeft() + selectedAssetPosX }, 500);
            }
        });

        $this.find('.title-subtext-description').each(function () {
            let $descriptionElement = $(this);
            let charLimit = 0;
            if (app.window.width() >= app.grid.lg) {
                charLimit = $descriptionElement.length ? $descriptionElement.attr('data-desktop-char-limit') : 0;
            } else if (app.window.width() > app.grid.md) {
                charLimit = $descriptionElement.length ? $descriptionElement.attr('data-tablet-char-limit') : 0;
            } else {
                charLimit = $descriptionElement.length ? $descriptionElement.attr('data-mobile-char-limit') : 0;
            }
            if (charLimit && $descriptionElement.text().length > charLimit) {
                let originalText = $descriptionElement.text().trim();
                let truncatedText = originalText.substring(0, charLimit).trim() + '…';
                $descriptionElement.text(truncatedText);
            }
        });
    });
});
